import type { BillForm, BillFormLine } from './formData'

const REPLACEABLE_LINE_FIELDS: (keyof BillFormLine)[] = ['description', 'bookkeepingTag', 'expenseCategory', 'taxRate']

export const isBillLineReplaceableByAttachmentData = (billForm: BillForm): boolean => {
  if (billForm.billLines?.length !== 1) {
    return false
  }

  const billLine = billForm.billLines[0]

  return REPLACEABLE_LINE_FIELDS.every((property) => {
    return !billLine[property] || !!billForm.autoCompletedFields?.[`billLines.0.${property}`]
  })
}
